import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useState } from 'react'

import { useCancelSaga } from '@/hooks/useInsuranceSagas'

/**
 * Zrušení čekajícího požadavku na storno — tenká storno-obálka nad obecným zrušením retryable sagy.
 * Zrušení se zpracovává asynchronně; výsledný stav smlouvy dorazí přes InsuranceSagaContext (SagaWorkflowHub).
 */
export const CancelStornoRequest = ({
  sagaId,
  callback,
}: {
  sagaId: string
  callback: () => void
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { mutateAsync: cancelSaga, isPending } = useCancelSaga()
  const [error, setError] = useState<string | null>(null)

  const handleOpen = () => {
    setError(null)
    onOpen()
  }

  const handleConfirm = async () => {
    setError(null)
    try {
      const res = await cancelSaga({ sagaId, reason: 'Zrušení požadavku na storno uživatelem.' })
      if (!res.success) {
        setError(res.error ?? 'Zrušení požadavku na storno se nezdařilo.')
        callback() // stav se mezitím mohl změnit (např. storno již proběhlo) — obnovit data
        return
      }
      callback()
      onClose()
    } catch {
      setError('Zrušení požadavku na storno se nezdařilo.')
    }
  }

  return (
    <>
      <Button variant="outline" colorScheme="red" onClick={handleOpen}>
        Zrušit požadavek na storno
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Zrušit požadavek na storno</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Opravdu chcete zrušit čekající požadavek na storno této smlouvy?</Text>
            {error && (
              <Alert status="error" mt={4}>
                <AlertIcon />
                <Text>{error}</Text>
              </Alert>
            )}
          </ModalBody>
          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={onClose} isDisabled={isPending}>
              Zrušit
            </Button>
            <Button colorScheme="red" onClick={handleConfirm} isLoading={isPending}>
              Potvrdit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
